export interface PrioritasiRisikoDepartemenDataModel {
    ulid: string;
    name: string;
    description: string;
    status: string;
    rcsa: any;
    total_skor: number;
    nilai_prioritasi: any[];
  }

export interface PemantauanIRUDataModel {
    id: number;
    ulid: string;
    code?: any;
    pemilik_data_iru: number;
    id_risiko_utama: number;
    indikator_risiko_utama: string;
    formula: string;
    unit: string;
    entity_id?: any;
    project_assignment_id?: any;
    id_status?: any;
    status?: any;
    properties?: any;
    created_at: string;
    updated_at: string;
    risiko_utama: Risikoutama;
    treatment_current_month: any;
    treatment_descriptions: any[];
    deskripsi_treshold: Deskripsitreshold[];
  }
  interface Deskripsitreshold {
    value: number[] | number;
    priority: number;
    kri_treshold: Kritreshold;
    color: string;
    name: string;
  }
  interface Kritreshold {
    ulid: string;
    code?: any;
    name: string;
    description?: any;
    color: string;
    priority: number;
    status: string;
    properties?: any;
  }
  interface Risikoutama {
    ulid: string;
    total_skor: string;
    is_risiko_utama: boolean;
    id_risiko_utama: string;
    entity_id?: any;
    project_assignment_id?: any;
    id_status: number;
    status: string;
    properties?: any;
    created_at: string;
    updated_at: string;
    agregasi_risiko: any
  }

  export interface PemantauanKRIModel {
    pemantauanMain: {
      data: PrioritasiRisikoDepartemenDataModel[];
      total: number;
    };
    pemantauanIRUMain: {
      data: PemantauanIRUDataModel[];
      total: number;
    };
    detailPemantauan: any;
  }
  
  export enum PemantauanKRIActionType {
    GetPemantauanKRI = "Configure/KRI/GetPemantauanKRI",
    GetPemantauanIRU = "Configure/KRI/GetPemantauanIRU",
    GetDetailPemantauanKRI = "Configure/KRI/GetDetailPemantauanKRI",
  }
  
  export type PemantauanKRIAction =
    | {
        type: PemantauanKRIActionType.GetPemantauanKRI;
        data: {
          data: PrioritasiRisikoDepartemenDataModel[];
          total: number;
        };
      }
    | {
        type: PemantauanKRIActionType.GetPemantauanIRU;
        data: {
          data: PemantauanIRUDataModel[];
          total: number;
        };
      }
    | {
        type: PemantauanKRIActionType.GetDetailPemantauanKRI;
        data: any
      }
  